import { render } from "./PrintAIVoucherButton.vue?vue&type=template&id=05b7fc46&scoped=true"
import script from "./PrintAIVoucherButton.vue?vue&type=script&lang=js"
export * from "./PrintAIVoucherButton.vue?vue&type=script&lang=js"

import "./PrintAIVoucherButton.vue?vue&type=style&index=0&id=05b7fc46&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05b7fc46"

export default script